import styled from '@emotion/styled';

export const Upper = styled.div`
  @media screen and (max-width: 4000px) {
    padding: 20px 200px;
    .header {
      font-family: Roboto;
      font-style: normal;
      font-weight: bold;
      font-size: 30px;
      line-height: 56px;
      text-align: center;
    }
    .content {
      font-family: Source Sans Pro;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 25px;
      text-align: center;
    }
  }
  @media screen and (max-width: 700px) {
    padding: 48px 30px;
    .header {
      font-family: Roboto;
      font-style: normal;
      font-weight: bold;
      font-size: 24px;
      line-height: 56px;
      text-align: center;
    }
    .content {
      font-family: Source Sans Pro;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 30px;
      text-align: center;
    }
  }
  background: linear-gradient(
    180deg,
    #fff8c1 18.18%,
    rgba(255, 248, 193, 0) 100%
  );
`;

export const Card = styled.div`
  @media screen and (max-width: 4000px) {
    padding: 4px 4px;
    margin: 16px 0px;
    .title {
      font-family: Roboto;
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 37px;
      text-align: center;
    }
    .description {
      font-family: Source Sans Pro;
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 30px;
      text-align: center;
    }
  }
  @media screen and (max-width: 700px) {
    padding: 30px 24px;
    margin: 0;
    .title {
      font-family: Roboto;
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 37px;
      text-align: center;
    }
    .description {
      font-family: Source Sans Pro;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 30px;
      text-align: center;
    }
  }
  background: #f5f6f8;
  border: 2px solid #000000;
  box-sizing: border-box;
  border-radius: 8px;
`;

export const ItemDescription = styled.div`
  @media screen and (max-width: 4000px) {
    p {
      font-family: Source Sans Pro;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 30px;
      margin: 8px 32px;
    }
    margin: 8px 32px;
  }
  @media screen and (max-width: 700px) {
    p {
      font-family: Source Sans Pro;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 20px;
    }
    margin: 8px 0;
  }
  margin: 8px 32px;
  display: flex;
  justify-content: space-between;
`;

export const ButtonKlaim = styled.div`
  margin: 2px 0;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 30px;
`;
